import type { ICustomModuleEntry } from './ICustomModuleEntry';

/**
 * Реєстр власних модулів робочих просторів (ADR-025) для моделі навігації: модель (navigation.json) знає лише опубліковані модулі, тож
 * власні модулі з каталогу простору (kind 'custom') реєструє запит каталогу (metadataApi), а moduleNav, groupModules і групи верхнього
 * меню беруть їх звідси. Ключі різних просторів не перетинаються (mod_ + випадкові символи); показ фільтрує каталог поточного простору.
 * Файл без залежностей — його імпортує шар стану, не створюючи циклу з навігацією.
 */
const byWorkspace = new Map<string, readonly ICustomModuleEntry[]>();

/** Замінює власні модулі простору (порядок — порядок каталогу: нові модулі — наприкінці, як ws.modules прототипу). */
export function registerCustomModules(workspaceId: string, modules: readonly ICustomModuleEntry[]): void {
  if (modules.length) byWorkspace.set(workspaceId, modules.map((m) => ({ key: m.key, category: m.category })));
  else byWorkspace.delete(workspaceId);
}

/** Категорія власного модуля за ключем; опублікований чи невідомий модуль — undefined. */
export function customModuleCategory(key: string): string | undefined {
  for (const list of byWorkspace.values()) {
    const found = list.find((m) => m.key === key);
    if (found) return found.category;
  }
  return undefined;
}

/** Ключі власних модулів категорії (усіх просторів, у порядку реєстрації). */
export function customModulesIn(category: string): string[] {
  return [...byWorkspace.values()].flatMap((list) => list.filter((m) => m.category === category).map((m) => m.key));
}
